import React from 'react';
import styles from './styles.scss';

import { Icons } from '@densityco/ui';

export default ({error}: {error?: any}) => (
  <div className={styles.error}>
    <h1>
      <Icons.Error color="currentColor" />
      <span>Error loading data</span>
    </h1>
    {error ? (
      <details>
        <summary>View error details</summary>
        <pre>
          {error instanceof Error ? error.stack : error.toString()}
        </pre>
      </details>
    ) : (
      <p>Please try again later.</p>
    )}
  </div>
);
